import * as Yup from 'yup';

export const formSchema = [
  {
    name: 'newPassword',
    validate: Yup.number()
      .typeError('Mật khẩu phải là số')
      .test(
        'len',
        'Mật khẩu phải đủ 6 kí tư',
        (val) => val?.toString().length === 6,
      ),
  },
  {
    name: 'confirmNewPassword',
    validate: Yup.number()
      .typeError('Mật khẩu phải là số')
      .test({
        message: 'Mật khẩu không trùng khớp',
        test: function (value) {
          const password = this.resolve(Yup.ref('newPassword'));
          if (password && value && value !== password) return false;
          return true;
        },
      }),
  },
];
